import { getMachineMeta } from '@internal/services/apiClient'
import {
  FinalMachineMergeResultNotReachedError,
  MachineNotFoundError,
} from '@internal/utils/errors/machineErrors'
import axios from 'axios'
import { getSSRMachineTypeName } from 'i18n/getSSRMachineTypeName'
import { SystemPageKey } from 'page/SystemPageKey'
import { buildMachineUrlPathParams } from 'utils/routing/buildMachineUrlPathParams'
import { urlFor } from '../urls/urlFor'
import { TRedirectGenerator } from './TRedirectGenerator'
import { MachineGroupIdSchemaCaseInsensitive } from '@internal/utils/machine/isValidMachineGroupId'

export const getRedirectForMachine: TRedirectGenerator<{
  machineGroupId?: string
}> = async ({ pathParams, locale, queryParams }) => {
  const result = MachineGroupIdSchemaCaseInsensitive.safeParse(
    pathParams.machineGroupId
  )
  if (!result.success) {
    return false
  }

  const machineGroupId = result.data

  try {
    /**
     * because this code runs on the server in the edge runtime (or at least next thinks that at build time)
     * we cannot consume the authenticatedMachineSearchClient
     * in order to work around that we call an internal api that does the call to the machine search service
     */

    const machine = await getMachineMeta({
      machineGroupId,
      resolveMerged: true,
    })

    if (!machine?.pdp) {
      return false
    }

    return urlFor(locale, {
      key: SystemPageKey.PDP,
      pathParams: {
        ...buildMachineUrlPathParams(locale, {
          machineGroupId: machine.machineGroupId,
          brand: machine.brand,
          model: machine.model,
          machineTypeName: getSSRMachineTypeName(
            locale,
            machine.machineType,
            'plural'
          ),
        }),
      },
      queryParams,
    })
  } catch (err) {
    if (
      !(
        err instanceof MachineNotFoundError ||
        err instanceof FinalMachineMergeResultNotReachedError
      )
    ) {
      if (axios.isAxiosError(err)) {
        console.error(
          JSON.stringify({
            status: err.response?.status,
            statusText: err.response?.statusText,
            message: err.message,
            stack: err.stack,
          })
        )
      } else if (err instanceof Error) {
        console.error(
          JSON.stringify({
            message: err.message,
            stack: err.stack,
          })
        )
      } else {
        console.log(`Error in getRedirectForMachine`)
      }
    }

    return false
  }
}
